import { publicEnv } from "config/constants";
import { useScript } from "./useScript";

const gRecaptchaSiteKey = publicEnv("GRECAPTCHA_SITE_KEY");

const useRecaptcha = () => {
  useScript(
    `https://www.google.com/recaptcha/api.js?render=${gRecaptchaSiteKey}`
  );

  return () =>
    new Promise<string>(function (resolve) {
      window.grecaptcha.ready(async () => {
        const token = await window.grecaptcha.execute(gRecaptchaSiteKey, {
          action: "submit",
        });
        resolve(token);
      });
    });
};

export { useRecaptcha, gRecaptchaSiteKey };
